import { Navigate } from 'react-router';

import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

/**
 * The CLM Evolution route prefix moved from `/workflows-clm-evolution` to
 * `/workflows`, and its `workflows` segment was later renamed to
 * `workflow-builder`. Keeps old bookmarks and shared links working by
 * forwarding everything under the retired prefix — path and query string
 * included — to the same location under the current one.
 */
export const LegacyClmEvolutionRouteRedirect = () => {
  const { params, location } = useRouting();
  const rest = (params['*'] ?? '').replace(
    /^workflows(\/|$)/,
    'workflow-builder$1',
  );

  // A bookmark to the bare section root (no subpath) has nothing to append —
  // `/workflows/` alone isn't a real route, so land on Requests instead of a
  // dead link.
  const to = rest
    ? `/workflows/${rest}${location.search}`
    : `${RoutePathType.WorkflowCLMEvolutionRequests}${location.search}`;

  return <Navigate replace to={to} />;
};
